import React from 'react';
import { useDispatch } from 'react-redux';
import Map from 'components/Map';
import MapSettings from 'components/Map/settings';
import { zoomToFeature } from 'components/Map/helper';
import { geojsonToArcGIS } from '@terraformer/arcgis';
import { setCurrentTeam } from 'redux/team/actions';

const { modules } = MapSettings;

const extraMapModules = [modules.webMercatorUtils, modules.polygon];
const symbolColors = {
  fulfilled: 'rgba(0, 45, 156, 0.35)',
  expired: 'rgba(141, 141, 141, 0.35)',
  other: 'rgba(138, 63, 252, 0.35)'
};

const MapView: React.FC<Props> = ({ shape, divRef, status, isExpired }) => {
  const dispatch = useDispatch();
  const symbolColor = isExpired
    ? 'expired'
    : status === 'fulfilled' || status === 'expired'
    ? status
    : 'other';
  const onMapReady = () => {
    const { loadedMap, loadedMapModules, loadedView } = window;
    if (loadedMap) {
      const { GraphicsLayer, Graphic, WebMercatorUtils } = loadedMapModules;

      const enquiriesLayer = new GraphicsLayer({
        id: 'enquiries-layer'
      });
      const geometry = geojsonToArcGIS(shape);
      const webMercatorGeometry =
        WebMercatorUtils.geographicToWebMercator(geometry);
      const graphic = new Graphic({
        geometry: {
          ...webMercatorGeometry,
          type: 'polygon'
        },
        symbol: {
          type: 'simple-fill',
          color: symbolColors[symbolColor],
          style: 'solid',
          outline: { style: 'none' }
        }
      });
      enquiriesLayer.add(graphic);
      zoomToFeature(graphic.geometry.extent, 0, true);
      loadedMap.add(enquiriesLayer);

      loadedView.ui.move('zoom', 'top-left');
      dispatch(
        setCurrentTeam({
          id: 1,
          name: '',
          shape
        })
      );
    }
  };

  return (
    <div
      ref={divRef}
      className="map-view-container"
      data-testid="AnonymousView"
    >
      <Map
        extraModules={extraMapModules}
        onReady={onMapReady}
        showHomeButton={true}
      />
    </div>
  );
};

type Props = {
  shape: any;
  status: string;
  isExpired?: boolean;
  divRef?: React.MutableRefObject<HTMLDivElement | null>;
};

MapView.displayName = 'HomeMapView';

export default MapView;
